// THIS FILE WAS AUTO GENERATED, @see acc-client-selection.sh
import deDynamic from "./i18n/vodafone-de_dynamic"
import enDynamic from "./i18n/vodafone-en_dynamic"
import Logo from "./images/vodafone-logo.svg";
import LogoSmall from "./images/vodafone-logo-small.svg";

export const accDeDynamic = deDynamic;
export const accEnDynamic = enDynamic;
export const AccLogo = Logo;
export const AccLogoSmall = LogoSmall;

export * from "./js/vodafone-client-config";
export * from "./js/vodafone-Colors";
